export default "__VITE_PUBLIC_ASSET__d15c17e0__"